export const data = [
  {
    title: 'Oral',
    content: [
      {
        title: 'Attention for Adversarial Attacks: Learning from your Mistakes;',
        author: 'Florian Jaeckle, Aleksandr Agadzhanov, JINGYUE LU, M. Pawan Kumar;',
        link: 'https://openreview.net/forum?id=1o5Bzo7BO3v'
      },
      {
        title: 'Demystifying the Adversarial Robustness of Random Transformation Defenses;',
        author: 'Chawin Sitawarin, Zachary Golan-Strieb, David Wagner;',
        link: 'https://openreview.net/forum?id=p4SrFydwO5'
      },
      {
        title: 'Revisiting Adversarial Robustness of Classifiers With a Reject Option;',
        author: 'Jiefeng Chen, Jayaram Raghuram, Jihye Choi, Xi Wu, Yingyu Liang, Somesh Jha;',
        link: 'https://openreview.net/forum?id=UiF3RTES7pU'
      }
    ]
  },
  {
    title: 'Long Paper',
    content: [
      {
        title: 'Detecting Adversaries, yet Faltering to Noise? Leveraging Conditional Variational AutoEncoders for Adversary Detection in the Presence of Noisy Images;',
        author: 'Dvij Rajesh Kalaria, Aritra Hazra, Partha Pratim Chakrabarti;',
        link: 'https://openreview.net/forum?id=Ex1yemaQgU'
      },
      {
        title: 'Provable Defense Against Clustering Attacks on 3D Point Clouds;',
        author: 'Dishanika Dewani Denipitiyage, Thalaiyasingam Ajanthan, Parameswaran Kamalaruban, Adrian Weller;',
        link: 'https://openreview.net/forum?id=p4SrFydwO5'
      },
      {
        title: 'Traversing the Local Polytopes of ReLU Neural Networks;',
        author: 'Shaojie Xu, Joel Vaughan, Jie Chen, Aijun Zhang, Agus Sudjianto;',
        link: 'https://openreview.net/forum?id=EQjwT2-Vaba'
      },
      {
        title: 'Tensor Normalization and Full Distribution Training;',
        author: 'Wolfgang Fuhl, Enkelejda Kasneci;',
        link: 'https://openreview.net/forum?id=035VtDXUjLN'
      },
      {
        title: 'Saliency Diversified Deep Ensemble for Robustness to Adversaries;',
        author: 'Alex Bogun, Dimche Kostadinov, Damian Borth;',
        link: 'https://openreview.net/forum?id=wGkmGrDsco8'
      },
      {
        title: 'Training Universal Adversarial Perturbations with Alternating Loss Functions;',
        author: 'Deniz Sen, Berat Tuna KARLI, Alptekin Temizel;',
        link: 'https://openreview.net/forum?id=gVe36H8OrHW'
      },
      {
        title: 'Robust Out-of-distribution Detection for Neural Networks;',
        author: 'Jiefeng Chen, Yixuan Li, Xi Wu, Yingyu Liang, Somesh Jha;',
        link: 'https://openreview.net/forum?id=WMIoz7O_DPz'
      },
      {
        title: 'Estimating the Robustness of Classification Models by the Structure of the Learned Feature-Space;',
        author: 'Kalun Ho, Avraam Chatzimichailidis, Franz-Josef Pfreundt, Janis Keuper, Margret Keuper;',
        link: 'https://openreview.net/forum?id=UHBsuFPrJ11'
      },
      {
        title: 'Improving Perceptual Quality of Adversarial Images Using Perceptual Distance Minimization and Normalized Variance Weighting;',
        author: 'Berat Tuna KARLI, Deniz Sen, Alptekin Temizel;',
        link: 'https://openreview.net/forum?id=rq2hMS4OaUX'
      },
      {
        title: 'Broad Adversarial Training with Data Augmentation in the Output Space;',
        author: 'Nils Worzyk, Stella Yu;',
        link: 'https://openreview.net/forum?id=EfhpoMWSqUN'
      },
      {
        title: 'Ensemble-in-One: Learning Ensemble within Random Gated Networks for Enhanced Adversarial Robustness;',
        author: 'Yi Cai, Xuefei Ning, Yu Wang, Huazhong Yang;',
        link: 'https://openreview.net/forum?id=og7CXiEXqpZ'
      },
      {
        title: 'BiGrad: Differentiating through Bilevel Optimization Programming;',
        author: 'Francesco Alesiani;',
        link: 'https://openreview.net/forum?id=HvRAM-dpmEv'
      },
      {
        title: 'Metamorphic Adversarial Detection Pipeline for Face Recognition Systems;',
        author: 'Rohan Reddy Mekala, Sai Yerramreddy, Adam Porter;',
        link: 'https://openreview.net/forum?id=defs2E_Mrf0'
      },
      {
        title: 'Measuring the Contribution of Multiple Model Representations in Detecting Adversarial Instances;',
        author: 'Daniel Steinberg, Paul Munro;',
        link: 'https://openreview.net/forum?id=LGlhzn1ZJl'
      },
      {
        title: 'Optimal Robust Classification Trees;',
        author: 'Nathan Justin, Sina Aghaei, Andres Gomez, Phebe Vayanos;',
        link: 'https://openreview.net/forum?id=HbasA9ysA3'
      },
      {
        title: 'A Practical and Stealthy Adversarial Attack for Cyber-Physical Applications;',
        author: 'Yifu Wu, Jin Wei-Kocsis;',
        link: 'https://openreview.net/forum?id=Dp5B1YhYlwY'
      },
      {
        title: 'Robust No-Regret Learning in Min-Max Stackelberg Games;',
        author: 'Denizalp Goktas, Jiayi Zhao, Amy Greenwald;',
        link: 'https://openreview.net/forum?id=u_lOumlm7mu'
      }
    ]
  },
  {
    title: 'Short paper',
    content: [
      {
        title: 'Aliasing coincides with CNNs vulnerability towards adversarial attacks;',
        author: 'Julia Grabinski, Janis Keuper, Margret Keuper;',
        link: 'https://openreview.net/forum?id=vKc1mLxBebP'
      },
      {
        title: 'An Adversarial Benchmark for Fake News Detection Models;',
        author: 'Lorenzo Jaime Yu Flores, Yiding Hao;',
        link: 'https://openreview.net/forum?id=n3PMOhS42s6'
      },
      {
        title: 'Is RobustBench/AutoAttack a suitable Benchmark for Adversarial Robustness?;',
        author: 'Peter Lorenz, Dominik Strassel, Margret Keuper, Janis Keuper;',
        link: 'https://openreview.net/forum?id=aLB3FaqoMBs'
      },
      {
        title: 'The Diversity Metrics of Sub-models based on SVD of Jacobians for Ensembles Adversarial Robustness;',
        author: 'Ruoxi Qin, Linyuan Wang, Xuehui Du, Bin Yan, Xingyuan Chen;',
        link: 'https://openreview.net/forum?id=Z8lffFu2rTT'
      },
      {
        title: 'Heterogeneous Architecture Search Approach within Adversarial Dynamic Defense Framework;',
        author: 'Qi Peng, Ruoxi Qin, Wenlin Liu, Libin Hou, Bin Yan, Linyuan Wang;',
        link: 'https://openreview.net/forum?id=1RALS1IpSh8'
      },{
        title: 'Mitigation of Adversarial Policy Imitation via Constrained Randomization of Policy (CRoP);',
        author: 'Nancirose G Piazza, Vahid Behzadan;',
        link: 'https://openreview.net/forum?id=o_O7TOBC7jl'
      },
      {
        title: 'Patch Vestiges in the Adversarial Examples Against Vision Transformer Can Be Leveraged for Adversarial Detection;',
        author: 'Juzheng Li;',
        link: 'https://openreview.net/forum?id=Y3fjmc2vkKA'
      },
      {
        title: 'Meta Adversarial Perturbations;',
        author: 'Chia-Hung Yuan, Pin-Yu Chen, Chia-Mu Yu;',
        link: 'https://openreview.net/forum?id=gP4WxGjNd3k'
      },
    ]
  },
  {
    title: 'Competition Papers',
    content: [
      {
        title: '#1: Goal-Oriented Data-Centric Robust Learning;',
        author: 'Zihao Wang, Zhengwei Fang',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank1.pdf'
      },
      {
        title: '#2: Data Enhancement with Multiple Adversarial Perturbation Constraints;',
        author: 'Wenkai Zheng, Jingzhou Luo, Peilun Du',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank2.pdf'
      },
      {
        title: '#3: Mix Saturation Attack Data like Cocktail for Robust Learning;',
        author: 'Jian Zhao, Xiangbin Liu, Shifan Lv',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank3.pdf'
      },
      {
        title: '#4: Exploiting the Potential of Datasets: A Data-Centric Approach for Model Robustness;',
        author: 'Yiqi Zhong, Lei Wu, Xianming Liu, Junjun Jiang',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank4.pdf'
      },
      {
        title: '#5: Improving Adversarial Robustness with Data-Centric Learning;',
        author: 'Xiang Ji, Qiwei Tian, Yulong Yang, Chenhao Lin, Qian Li, Chao Shen',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank5.pdf'
      },
      {
        title: '#6: Improve Data Robustness With Multiple Data Processing;',
        author: 'Hongyu Kan, Jun Shi, Hong An',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank6.pdf'
      },
      {
        title: '#7: Data-Centric Techniques To Robust ML Models;',
        author: 'Jian Gao, Jingying Tang, Fengling Lin',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank7.pdf'
      },
      {
        title: '#8: Towards Efficient Data-Centric Robust Machine Learning with Noise-based Augmentation;',
        author: 'Xiaogeng Liu, Haoyu Wang, Yechao Zhang, Fangzhou Wu, Shengshan Hu',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank8.pdf'
      },
      {
        title: '#10: Mining limited data for more robust and generalized ML models;',
        author: 'Jun Yu, Hao Chang, Keda Lu',
        link: 'http://alisec-competition.oss-cn-shanghai.aliyuncs.com/competition_papers/20211201/rank10.pdf'
      }
    ]
  }
]
